import React, { useEffect, useRef, useState } from 'react';
import {
  number, func
} from 'prop-types';
import { useViewportResize } from '../hooks/cabinetVisualizerHooks';

export const Viewport = ({ zoom = 1, render, onWidthChange, onScrollChange }) => {
  const { width, setElementRef } = useViewportResize(1);
  const [scrollOffset, setScrollOffset] = useState({ scrollLeft: 0, scrollTop: 0 });

  const viewportRef = useRef(null);
  const combinedRef = (node) => {
    setElementRef(node);
    viewportRef.current = node;
  };
  useEffect(() => {
    if (viewportRef.current !== null) {
      setTimeout(() => {
        viewportRef.current.scrollLeft = 0;
        viewportRef.current.scrollTop = viewportRef.current.scrollHeight - viewportRef.current.clientHeight;
      }, 0);
    }
  }, [width]);

  useEffect(() => {
    const handleScroll = () => {
      if (viewportRef.current) {
        setScrollOffset({
          scrollLeft: viewportRef.current.scrollLeft,
          scrollTop: viewportRef.current.scrollTop,
        });
        if (onScrollChange) {
          onScrollChange({
            scrollLeft: viewportRef.current.scrollLeft,
            scrollTop: viewportRef.current.scrollTop,
          });
        }
      }
    };

    const viewportEl = viewportRef.current;
    if (viewportEl) {
      viewportEl.addEventListener('scroll', handleScroll);
      return () => viewportEl.removeEventListener('scroll', handleScroll);
    }
    return () => {};
  }, [onScrollChange]);

  // Notify parent of width changes
  useEffect(() => {
    if (onWidthChange) {
      onWidthChange(width);
    }
  }, [width, onWidthChange]);

  return (
    <div ref={combinedRef} className="viewport">
      <div className="viewport-content">
        {render(width, scrollOffset)}
      </div>
    </div>
  );
};

Viewport.propTypes = {
  zoom: number,
  render: func,
  onWidthChange: func,
  onScrollChange: func
};

Viewport.defaultProps = {
  zoom: 1,
  render: () => undefined,
  onWidthChange: () => undefined,
  onScrollChange: () => undefined
};
